<template>
    <div class="fill">
        <div class="flex-box index-bd">
            <div class="left-box bg-menu flex-box col">
                <div class="pd-10">
                    <div class="flex-box nopadding">
                        <div><img class="img-32 round-2" :src="loadData.org_img_lnk || ($config.imgUrlCom + 'logo200.png')"/></div>
                        <div class="mg-left5 f15 f-bd">{{loadData.org_cname}}</div>
                    </div>
                    <div class="flex-box nopadding mg-top10">
                        <div class="flex-box-bd">
                            <el-dropdown trigger="click" @command="userBoxClick">
                            <span class="el-dropdown-link hand f-white text-nowrap">
                                {{loadData.user_code}}
                                <Icon type="ios-arrow-down"></Icon>
                            </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="reset_pwd">{{ $t("reset_pwd")}}</el-dropdown-item>
                                    <el-dropdown-item command="logout">{{ $t("exit") }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="flex-box-bd">
                            <a class="hand f14 f-white" @click="openRole">
                                {{loadData.role_cname}}
                                <Icon type="ios-arrow-down"></Icon>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="item1 flex-box-bd mini-scrollbar" style="overflow-y: auto">
                    <div class="img-box">
                        <img :src="`${img_path}bg_sm.jpg`" style="opacity: 0.8" />
                    </div>
                    <el-menu ref="menu" class="el-menu-vertical-demo bg-back-main pd-left5 pd-right5" :unique-opened="true" :default-active="menu_active_name" :router="true">
                        <el-menu-item class="el-submenu__title" route="/index/welcome" index="/index/welcome">
                            <Icon size="18" type="ios-desktop" style="color:#0081ff" />
                            <span class="f14 f-white" style="font-weight: 500">概览</span>
                        </el-menu-item>
                        <el-submenu :index="item.web_url" v-for="(item,index) in loadData.menu_list" :key="index">
                            <template slot="title">
                                <Icon size="18" :type="item.icon" :color="item.color || '#fff'" />
                                <span class="f14" style="font-weight: 500">{{item.func_cname}}</span>
                            </template>
                            <el-menu-item class="f12" :route="item2.web_url+'?fid='+item2.func_id+'&fn='+item2.func_cname" :index="item2.web_url" v-for="(item2,index2) in item.children" :key="index2">
                                <span style="font-weight: 500" :style="{color:item2.color==''?'#fff':item2.color}">• {{item2.func_cname}}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
                <div class="flex-box pd-5 bgs-box">
                    <div class="flex-box-bd" v-for="(item) in bgs" :key="item.key">
                        <el-tooltip :content="item.value" placement="bottom" style="margin: 0 auto">
                            <div class="click-block bg-card hand" :class="item.bg_color" @click="changeBg(item.key)"></div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="flex-box-bd right-box">
                <div class="flex-box col fillwh">
                    <div style="height: 10px"></div>
                    <myMenuOpens></myMenuOpens>
                    <div class="flex-box-bd" style="position: relative">
                        <keep-alive :include="menu_opens_name" :max="$config.cache_page_qty * 2">
                            <router-view class="sub-view"></router-view>
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="$t('reset_pwd')" :modal="false" :close-on-click-modal="false" :visible.sync="show_reset_pwd" width="400px">
            <el-form :model="password">
                <el-form-item :label="$t('new_pwd')" label-width="120">
                    <el-input ref="user_pwd" type="password" v-model="password.user_pwd" autocomplete="off" @keyup.enter.native="resetPwd"></el-input>
                </el-form-item>
                <el-form-item :label="$t('chk_pwd')" label-width="120">
                    <el-input type="password" v-model="password.user_pwd2" autocomplete="off" @keyup.enter.native="resetPwd"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="show_reset_pwd = false">{{ $t("cancel")}}</el-button>
                <el-button type="primary" @click="resetPwd">{{ $t("save")}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import myMenuOpens from '../components/myMenuOpens'
    export default {
        name: "index",
        components:{
            myMenuOpens
        },
        data:function(){
            return{
                lang: this.$base.getLang(),
                img_path:this.$config.imgUrl,
                show_reset_pwd: false,
                loadData:{
                    user_code: this.$t("weizhi"),
                    role_cname: this.$t("weizhi"),
                    org_cname: this.$t("weizhi"),
                    org_img_lnk: '',
                    menu_list: [],
                    coll_menu_list: []
                },
                password:{
                    user_pwd: '',
                    user_pwd2: ''
                },
                bgs:[{
                    key:'theme_df',
                    value:'海蓝',
                    bg_color:'bg-blue'
                },{
                    key:'theme_cyan',
                    value:'天清',
                    bg_color:'bg-cyan'
                },{
                    key:'theme_orange',
                    value:'橘橙',
                    bg_color:'bg-orange'
                },{
                    key:'theme_brown',
                    value:'棕褐',
                    bg_color:'bg-brown'
                },{
                    key:'theme_purple',
                    value:'姹紫',
                    bg_color:'bg-purple'
                }],
            }
        },
        computed:{
            base_reload: function() {
                return this.$store.state.baseData.base_reload;
            },
            menu_open_names:function () {
                return [this.menu_active_name.split('/')[1]];
            },
            menu_active_name:function () {
                var ss = this.$store.state.baseData.menu_active_name.split('/');
                return '/'+ss[1]+'/'+ss[2];
            },
            menu_opens_name: function() {
                return this.$store.state.baseData.menu_opens_name;
            },
        },
        mounted:function(){
            document.title = this.$t('sys_name');
            window.changeRole = this.$base.changeRole; //切换角色时用
            this.load();
        },
        methods: {
            load: function() {
                this.$store.commit("setBaseData_baseReload", false);
                this.$base.showLoading();
                this.loadData.menu_list = []; //更换element ui后  切换身份需要重置当前menulist  否则会造成导航错误的bug
                this.$request.sendPost("user/base",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if(data.role_id == ''){
                            this.$base.logout();
                            return;
                        }
                        this.$base.setModCat(data.mod_cat);
                        this.loadData.user_code = data.user_code;
                        this.loadData.role_cname = data.role_cname;
                        this.loadData.org_cname = data.org_cname;
                        this.loadData.org_img_lnk = data.org_img_lnk;
                        this.loadData.coll_menu_list = data.coll_menu_list;
                        this.loadData.menu_list = data.menu_list;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            userBoxClick: function(name){
                if(name == "logout"){
                    this.$base.logout();
                }
                else if(name == "reset_pwd"){
                    this.show_reset_pwd = true;
                }
            },
            openRole: function () {
                this.$base.openRole();
            },
            resetPwd: function() {
                var user_pwd = this.password.user_pwd;
                if(user_pwd == ""){
                    this.$base.msgErr(this.$t('input_user_pwd'));
                    return;
                }
                if(user_pwd != this.password.user_pwd2){
                    this.$base.msgErr(this.$t('user_pwd_err'));
                    this.password.user_pwd = '';
                    this.password.user_pwd2 = '';
                    return;
                }
                var data = {
                    user_pwd: this.$base.toMD5(user_pwd)
                };
                this.$base.showLoading();
                this.$request.sendPost('user/set-pwd-by-self',data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.show_reset_pwd = false;
                        this.password.user_pwd = '';
                        this.password.user_pwd2 = '';
                        this.$base.msgSuccess(error.errmsg);
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            collFunc: function() {
                var func_id = this.$base.getRequest().fid;
                if(!func_id && func_id == ""){
                    this.$base.msgErr(this.$t('coll_err'));
                    return;
                }
                var data = {
                    func_id: func_id
                };
                this.$base.showLoading();
                this.$request.sendPost('user/coll-func',data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(this.$t('coll_ok'));
                        this.loadData.coll_menu_list.push(data);
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            collFuncClick:function (item) {
                this.$base.linkTo(`${item.web_url}?fid=${item.func_id}&fn=${item.func_cname}`);
                document.body.click();
            },
            deleteColl (index, coll_id) {
                const data = {
                    coll_id
                }
                this.$request.sendPost('user/del-coll-func',data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.loadData.coll_menu_list.splice(index, 1);
                        this.$base.msgSuccess(this.$t('del_ok'));
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            highColl (index, coll_id, high_flag) {
                const data = {
                    coll_id,
                    high_flag: high_flag == '1' ? '0' : '1'
                }
                this.$request.sendPost('user/high-coll-func',data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if (high_flag == '1') {
                            this.loadData.coll_menu_list[index].high_flag = '0'
                        } else {
                            this.loadData.coll_menu_list[index].high_flag = '1'
                        }
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            changeBg:function (theme_key) {
                this.$base.setTheme(theme_key);
                this.$store.commit('setBaseData_themeKey',theme_key);
            },
        },
        watch:{
            base_reload(newVal,oldVal){
                if(newVal){
                    this.load();
                }
            }
        }
    }
</script>

<style scoped>
    .index-bd{
        position: absolute;
        top:0;
        left:0;
        right:0;
        bottom: 0;
        padding: 0;
        text-align: unset;
    }
    .index-bd .left-box{
        width: 265px;
        height: 100%;
        border-top-right-radius: 5px;
        /*border-left: solid 1px #e5e5e5;*/
    }
    .index-bd .left-box .item1 .img-box img{
        width: 100%;
        height: 72px;
    }
    .index-bd .left-box .ivu-menu{
        font-weight: bold;
        font-size: 14px;
    }
    .index-bd .left-box .ivu-menu .ivu-icon{
        font-size: 17px;
    }
    .index-bd .right-box{
        margin-left: 5px;
        position: relative;
        width: 100%;
        height: 100%;
    }
    .index-bd .right-box .sub-view{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        padding: 5px;
    }
    .bgs-box{
        opacity: 0.5;
    }
    .bgs-box:hover{
        opacity: 1;
    }
    .bgs-box .bg-card{
        width: 30px;
        height: 15px;
        border: 1px white solid;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue